/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import { BaseApiClient, RequestContext, ApiConfigManager, HttpRequestState } from '@sg/api/base-api-lib';
import { CurrenciesApiConfig } from '../api-config';

import { CurrenciesApi } from '../models';

@Injectable()
export class ExchangeRatesApiClient extends BaseApiClient<CurrenciesApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.currenciesApiConfig);
  }

  exchangeRatesControllerPostCurrenciesExchangeRatesSearch(
    params?: {
      body?: CurrenciesApi.ExchangeRatesSearchRequestDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrenyCode' | 'CurrencyNum' | 'IssueDate' | 'CreateDate' | 'ExchangeRate';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<CurrenciesApi.CurrencyUsdExchangeRateDtoExchangeRatesSortCriteriaDtoPagingResultDto>;
  exchangeRatesControllerPostCurrenciesExchangeRatesSearch(
    params?: {
      body?: CurrenciesApi.ExchangeRatesSearchRequestDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrenyCode' | 'CurrencyNum' | 'IssueDate' | 'CreateDate' | 'ExchangeRate';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<CurrenciesApi.CurrencyUsdExchangeRateDtoExchangeRatesSortCriteriaDtoPagingResultDto>>;
  exchangeRatesControllerPostCurrenciesExchangeRatesSearch(
    params?: {
      body?: CurrenciesApi.ExchangeRatesSearchRequestDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrenyCode' | 'CurrencyNum' | 'IssueDate' | 'CreateDate' | 'ExchangeRate';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<CurrenciesApi.CurrencyUsdExchangeRateDtoExchangeRatesSortCriteriaDtoPagingResultDto>;
  exchangeRatesControllerPostCurrenciesExchangeRatesSearch(
    params?: {
      body?: CurrenciesApi.ExchangeRatesSearchRequestDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrenyCode' | 'CurrencyNum' | 'IssueDate' | 'CreateDate' | 'ExchangeRate';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<CurrenciesApi.CurrencyUsdExchangeRateDtoExchangeRatesSortCriteriaDtoPagingResultDto>>;
  exchangeRatesControllerPostCurrenciesExchangeRatesSearch(
    params?: {
      body?: CurrenciesApi.ExchangeRatesSearchRequestDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrenyCode' | 'CurrencyNum' | 'IssueDate' | 'CreateDate' | 'ExchangeRate';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<CurrenciesApi.CurrencyUsdExchangeRateDtoExchangeRatesSortCriteriaDtoPagingResultDto>>;
  exchangeRatesControllerPostCurrenciesExchangeRatesSearch(
    params?: {
      body?: CurrenciesApi.ExchangeRatesSearchRequestDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrenyCode' | 'CurrencyNum' | 'IssueDate' | 'CreateDate' | 'ExchangeRate';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<CurrenciesApi.CurrencyUsdExchangeRateDtoExchangeRatesSortCriteriaDtoPagingResultDto>>;
  exchangeRatesControllerPostCurrenciesExchangeRatesSearch(
    params?: {
      body?: CurrenciesApi.ExchangeRatesSearchRequestDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CurrenyCode' | 'CurrencyNum' | 'IssueDate' | 'CreateDate' | 'ExchangeRate';
    },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    if (params) {
      requestContext.queryParams = this.createQueryParams(
        ['', 'pageSize', params.pageSize],
        ['', 'pageNumber', params.pageNumber],
        ['', 'sortDirection', params.sortDirection],
        ['', 'orderBy', params.orderBy]
      );
    }

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ =
      this.httpClient.post<CurrenciesApi.CurrencyUsdExchangeRateDtoExchangeRatesSortCriteriaDtoPagingResultDto>(
        `${this.basePath}/gateway/admin/exchange-rates/search`,
        params.body,
        <any>Object.assign(baseOptions, {})
      );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  exchangeRatesControllerGetCurrenciesExchangeRatesLatest(
    xSgUser?: string,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<Array<CurrenciesApi.LatestCurrencyExchangeRateDto>>;
  exchangeRatesControllerGetCurrenciesExchangeRatesLatest(
    xSgUser?: string,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<Array<CurrenciesApi.LatestCurrencyExchangeRateDto>>>;
  exchangeRatesControllerGetCurrenciesExchangeRatesLatest(
    xSgUser?: string,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<Array<CurrenciesApi.LatestCurrencyExchangeRateDto>>;
  exchangeRatesControllerGetCurrenciesExchangeRatesLatest(
    xSgUser?: string,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<Array<CurrenciesApi.LatestCurrencyExchangeRateDto>>>;
  exchangeRatesControllerGetCurrenciesExchangeRatesLatest(
    xSgUser?: string,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<Array<CurrenciesApi.LatestCurrencyExchangeRateDto>>>;
  exchangeRatesControllerGetCurrenciesExchangeRatesLatest(
    xSgUser?: string,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<Array<CurrenciesApi.LatestCurrencyExchangeRateDto>>>;
  exchangeRatesControllerGetCurrenciesExchangeRatesLatest(
    xSgUser?: string,

    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<Array<CurrenciesApi.LatestCurrencyExchangeRateDto>>(
      `${this.basePath}/gateway/admin/exchange-rates/search/latest`,
      null,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  exchangeRatesControllerPutCurrenciesExchangeRates(
    params?: { body?: Array<CurrenciesApi.ExchangeRateUpdateRequestDto>; xSgUser?: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<CurrenciesApi.ErrorResponse>;
  exchangeRatesControllerPutCurrenciesExchangeRates(
    params?: { body?: Array<CurrenciesApi.ExchangeRateUpdateRequestDto>; xSgUser?: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<CurrenciesApi.ErrorResponse>>;
  exchangeRatesControllerPutCurrenciesExchangeRates(
    params?: { body?: Array<CurrenciesApi.ExchangeRateUpdateRequestDto>; xSgUser?: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<CurrenciesApi.ErrorResponse>;
  exchangeRatesControllerPutCurrenciesExchangeRates(
    params?: { body?: Array<CurrenciesApi.ExchangeRateUpdateRequestDto>; xSgUser?: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<CurrenciesApi.ErrorResponse>>;
  exchangeRatesControllerPutCurrenciesExchangeRates(
    params?: { body?: Array<CurrenciesApi.ExchangeRateUpdateRequestDto>; xSgUser?: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<CurrenciesApi.ErrorResponse>>;
  exchangeRatesControllerPutCurrenciesExchangeRates(
    params?: { body?: Array<CurrenciesApi.ExchangeRateUpdateRequestDto>; xSgUser?: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<CurrenciesApi.ErrorResponse>>;
  exchangeRatesControllerPutCurrenciesExchangeRates(
    params?: { body?: Array<CurrenciesApi.ExchangeRateUpdateRequestDto>; xSgUser?: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<CurrenciesApi.ErrorResponse>(
      `${this.basePath}/gateway/admin/exchange-rates`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
